import React from 'react';
import { Dropdown, Menu } from 'antd';
import { Table, Icon, Button } from 'semantic-ui-react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { formatDate, getConversationLogContent, tripHtmlFromBody } from '../../../utils/functions';

import { TableHeader, TableEmptyMessage } from '../../shared/table';
import ConversationModalForm from './ConversationModalForm';
import AddEditStore from './store';
import moment from 'moment';
import { Link } from 'react-router-dom';
import * as api from '@stores/api';

const columns = [
  {},
  { title: 'Date/Time' },
  { title: 'Subject' },
  { title: 'Content' },
  { title: 'Caller/Sender Type' },
  { title: 'Caller/Sender' },
  { title: 'Receiver Type' },
  { title: 'Receiver' },
  { title: 'Created By' },
  { title: 'Correspondence Type' },
];

@observer
class CaseCorrespondence extends React.Component {
  state = {
    visible: false,
  };

  toggleModal = visible => () => {
    AddEditStore.handleResetBodyConversation();
    this.setState({ visible });
  };
  updateDimensions = () => {
    const tbl = document.getElementById('Table-correspondence');
    const formSize = window.functionGetElementFormForResize();
    const screenWidth = window.innerWidth;
    if (tbl) {
      if (formSize) {
        const percent = formSize / screenWidth;
        return (tbl.style.width = `${screenWidth * percent}px`);
      }
      return (tbl.style.width = `${screenWidth * 0.575}px`);
    }
    return null;
  };
  componentWillUnmount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  converDate = (datestr, showTime = true) => {
    const { conversationList } = AddEditStore;
    const utcServerTime = conversationList.utcServerTime;
    const utcLocalMinutes = new Date().getTimezoneOffset();
    const addminutes = utcServerTime.TotalMinutes + utcLocalMinutes;
    if (datestr) {
      if (datestr.search('/Date') !== -1) {
        const date = formatDate(datestr, true);
        return showTime
          ? moment(date, 'DD MMM YYYY, HH:mm')
              .add(addminutes, 'minutes')
              .format('DD/MM/YYYY - HH:mm')
          : moment(date, 'DD MMM YYYY, HH:mm')
              .add(addminutes, 'minutes')
              .format('DD/MM/YYYY');
      }
      return datestr;
    }
    return datestr;
  };

  converMinuteOrHour = (datestr, type) => {
    if (datestr) {
      if (datestr.search('/Date') !== -1) {
        const date = formatDate(datestr);
        if (type === 'hour') {
          return moment(date, 'DD MMM,YYYY').format('HH');
        } else {
          return moment(date, 'DD MMM,YYYY').format('MM');
        }
      }
      return 0;
    }
    return 0;
  };

  toggleModalEdit = (visible, record) => async () => {
    const conversationParam = {
      CallerSender: record.CallerSender,
      CallerSenderName: record.CallerSenderName,
      CallerSenderType: record.CallerSenderType === 'Staff' ? 3 : 1,
      ClinicId: record.ClinicId,
      Content: await getConversationLogContent(record.Id, 'Clinic').then(res => res?.content),
      ConversationType: record.CorrespondenceType,
      Id: record.Id,
      Receiver: record.Receiver,
      ReceiverName: record.ReceiverName,
      ReceiverType: record.ReceiverType === 'Staff' ? 3 : 1,
      SentDate: this.converDate(record.SentDate),
      Subject: record.Subject,
      allowCMToView: record.AllowCMToView,
      allowDoctorToView: record.AllowDoctorToView,
      callerSenderId: record.StaffId,
      hour: this.converMinuteOrHour(record.SentDate, 'hour'),
      minute: this.converMinuteOrHour(record.SentDate, 'minute'),
      receiverId: record.Receiver,
    };
    AddEditStore.setFieldsValue({ conversationParam });
    this.setState({ visible });
  };

  openModal = opt => {
    return AddEditStore.toggleModal(true, opt)();
  };

  renderDropdownMenu = record => (
    <Menu>
      <Menu.Item
        onClick={() =>
          this.openModal({
            modalType: 'confirm',
            onOk: () => AddEditStore.handleAllowConversation(record.Id),
            message: `Are you sure to ${!record.AllowCMToView ? 'allow' : 'disallow'} Clinic to view this entry?`,
          })
        }
      >
        {!record.AllowCMToView ? 'Allow CMs to view' : 'Disallow CMs to view'}
      </Menu.Item>
      <Menu.Item onClick={this.toggleModalEdit(true, record)}>Edit</Menu.Item>
      <Menu.Item
        onClick={() =>
          this.openModal({
            modalType: 'confirm',
            onOk: () => AddEditStore.handleDeleteConversation(record.Id),
            message: 'Are you sure to delete this entry?',
          })
        }
      >
        Delete
      </Menu.Item>
    </Menu>
  );

  renderTableBody = data => {
    return data.map((record, idx) => (
      <Table.Row negative={!record.AllowCMToView} key={idx}>
        <Table.Cell className="Cell-actions">
          <Dropdown trigger={['click']} overlay={this.renderDropdownMenu(record)}>
            <Icon name="ellipsis vertical" />
          </Dropdown>
        </Table.Cell>
        <Table.Cell className="cell-correspondence">{this.converDate(record.SentDate, true)}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.Subject}</Table.Cell>
        <Table.Cell>
          <div className="cell-correspondence-content-body">{tripHtmlFromBody(record.Content)}</div>
          {record.Content && (
            <div className="Cell-link">
              <Link onClick={this.toggleModalEdit(true, record)} to="#">
                View more
              </Link>
            </div>
          )}
        </Table.Cell>
        <Table.Cell className="cell-correspondence">{record.CallerSenderType}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.CallerSenderName}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.ReceiverType}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.ReceiverName}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.UserName}</Table.Cell>
        <Table.Cell className="cell-correspondence">{record.TypeLog}</Table.Cell>
      </Table.Row>
    ));
  };

  render() {
    const { conversationList, loading, clinicInfo } = AddEditStore;
    if (clinicInfo.ID === 0) return null;
    return (
      <React.Fragment>
        <div className="fluid-field" style={{ marginBottom: '1em' }}>
          {!api.isOnlySearch() && <Button color="blue" disabled={clinicInfo.ID === 0} onClick={this.toggleModal(true)}>
            Add New
          </Button>}
        </div>
        <div className="fluid-field table-correspondence" id="Table-correspondence">
          <Table sortable striped celled>
            <TableHeader columns={columns} />
            <Table.Body>
              {loading || !conversationList ? (
                <TableEmptyMessage colSpan={columns.length} />
              ) : (
                this.renderTableBody(toJS(conversationList.itemList))
              )}
            </Table.Body>
          </Table>
        </div>
        <ConversationModalForm visible={this.state.visible} onCancel={this.toggleModal(false)} />
      </React.Fragment>
    );
  }
}

export default CaseCorrespondence;
